/* eslint-disable react-hooks/exhaustive-deps */
import RespuestaServidor from './RespuestaServidor';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NoResponse = () => {
  return (
    <RespuestaServidor
      titulo="Error del servidor"
      texto="Lo sentimos, no hubo respuesta del servidor. Intenta de nuevo más tarde."
      icono={ErrorOutlineIcon}
      textoBoton="Reintentar"
      colorIcono="error"
      paginaANavegar={0}
    />
  );
};

export default NoResponse;
